import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onSearchBoxFocused = action('ON_SEARCH_BOX_FOCUSED_NEXT', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));

export default onSearchBoxFocused;
